import { render } from "./PermohonPengguna.vue?vue&type=template&id=5a8f38cf"
import script from "./PermohonPengguna.vue?vue&type=script&lang=js"
export * from "./PermohonPengguna.vue?vue&type=script&lang=js"

import "./PermohonPengguna.vue?vue&type=style&index=0&id=5a8f38cf&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__